module.exports = __webpack_public_path__ + "img/chinesecompany206.4c282dc3.png";